import EDC from '@/components/games/shared/globals';
import store from '@/store/index';
import CursorManager from '@/components/games/shared/cursor-manager';
import router from '@/router';
import Button from '@/components/games/shared/button';

/**
 *
 */
EDC.Games.GradeSelect.Scenes.Main = function () {};
/**
 *
 */
EDC.Games.GradeSelect.Scenes.Main.prototype.init = function () {
  this.bg = null;
  this.content = null;
  this.backButton = null;
  this.group = null;
  this.cursorManager = null;
  this.scale.off('resize', this.resize, this);
};
/**
 *
 */
EDC.Games.GradeSelect.Scenes.Main.prototype.create = function () {
  this.cursorManager = new CursorManager(this.game.canvas);
  this.bg = this.add.sprite(this.scale.width / 2, this.scale.height / 2, 'profile-summary-background');
  this.content = this.add.container();

  const logo = this.add.sprite(0, 0, 'logo');
  logo.setScale(1);

  const titleSpr = this.add.sprite(0, 0, 'grade-selection-title');
  titleSpr.setScale(1);
  titleSpr.setPosition(titleSpr.displayWidth / 2 + logo.displayWidth / 2,
    titleSpr.displayHeight / 2);

  const answerPanel = this.add.sprite(0, 0, 'grade-selection-answer-panel');
  answerPanel.setPosition(titleSpr.x, titleSpr.displayHeight + 350);
  answerPanel.setScale(1);

  logo.setPosition(170, titleSpr.displayHeight / 2);
  this.content.add(titleSpr);
  this.content.add(logo);
  this.content.add(answerPanel);

  this.addGrades(answerPanel);

  const url = new URL(window.location.href);
  if (url.searchParams.get('edit') === 'grade') {
    this.backButton = new Button(this, 100, 100).create('back-normal', 'back-hover');
    this.backButton.setClickCallback(this.onBackBtnClick.bind(this));
  }

  this.scale.on('resize', this.resize, this);
  this.resize({ width: this.scale.width, height: this.scale.height });
};

/**
 *
 */

EDC.Games.GradeSelect.Scenes.Main.prototype.addGrades = function (panel) {
  for (let i = -1; i < 7; i++) {
    const container = this.add.container(panel.x - panel.displayWidth / 2,
      panel.y - panel.displayHeight / 2);
    const { x, y } = this.getGradePositions(i);
    container.x += x;
    container.y += y;
    const back = this.add.sprite(0, 0, 'grade-selection-answer-back');
    const highlight = this.add.sprite(0, 0, 'grade-selection-answer-highlight').setVisible(false);
    container.x += highlight.displayWidth / 2;
    container.y += highlight.displayHeight / 2;
    const frame = this.add.sprite(0, 0, 'grade-selection-answer-frame');
    const grade = this.add.sprite(0, 0, `grade-selection-grade-${i}`);
    container.add(back);
    container.add(highlight);
    container.add(frame);
    container.add(grade);
    this.cursorManager.setDefaultDraggableEvents(container);
    container.setSize(200, 200);
    container.setInteractive();
    container.textKey = `${i}`;
    container.on('pointerover', this.onOver.bind(this, highlight), this);
    container.on('pointerout', this.onOut.bind(this, highlight), this);
    container.on('pointerup', this.onGradeSelect.bind(this, container), this);
    this.content.add(container);
  }
};

EDC.Games.GradeSelect.Scenes.Main.prototype.onOver = function (highlight) {
  highlight.setVisible(true);
};
EDC.Games.GradeSelect.Scenes.Main.prototype.onOut = function (highlight) {
  highlight.setVisible(false);
};

EDC.Games.GradeSelect.Scenes.Main.prototype.onGradeSelect = function (container) {
  this.tweens.add({
    targets: container,
    scaleX: 0.9,
    scaleY: 0.9,
    duration: 75,
    ease: 'Linear',
    yoyo: true,
  });
  this.cursorManager.resetCursor();
  store.dispatch('children/updateNewProfile', { grade: container.textKey });
  this.input.enabled = false;

  const url = new URL(window.location.href);
  if (url.searchParams.get('edit') === 'grade') {
    store.dispatch('children/updateActiveChild').then(() => {
      router.push({ name: 'profile' });
    });
  } else {
    this.time.delayedCall(500, this.nextScene, [], this);
  }
};

EDC.Games.GradeSelect.Scenes.Main.prototype.nextScene = function () {
  this.scene.start('mainGender');
};

EDC.Games.GradeSelect.Scenes.Main.prototype.getGradePositions = function (index) {
  const i = index + 1;
  const startingX = 135;
  const distanceX = 275;
  let x; let
    y;
  if (i > 3) {
    x = (i % 4) * distanceX + startingX;
    y = 300;
  } else {
    x = i * distanceX + startingX;
    y = 65;
  }
  return { x, y };
};

EDC.Games.GradeSelect.Scenes.Main.prototype.onBackBtnClick = function () {
  router.push({ name: 'profile' });
};


EDC.Games.GradeSelect.Scenes.Main.prototype.resize = function (gameSize) {
  const { width } = gameSize;
  const { height } = gameSize;

  this.cameras.resize(width, height);

  const bgW = this.bg.width;
  const neededScaleX = width / bgW;
  const bgH = this.bg.height;
  const neededScaleY = height / bgH;
  let neededScale = neededScaleX > neededScaleY ? neededScaleX : neededScaleY;
  this.bg.setScale(neededScale);
  this.bg.setPosition(width / 2, height / 2);

  this.content.setPosition(0, 0);
  this.content.setScale(1, 1);
  let bounds = this.content.getBounds();
  const contentWidth = bounds.width;
  const contentHeight = bounds.height;
  const scaleX = (width * 0.8) / contentWidth;
  const scaleY = (height * 0.8) / contentHeight;
  neededScale = scaleX > scaleY ? scaleY : scaleX;
  // neededScale = width > height ? scaleY : scaleX;
  this.content.setScale(neededScale);
  bounds = this.content.getBounds();
  this.content.setPosition((width - bounds.width) / 2, (height - bounds.height) / 2);

  if (this.backButton) {
    this.backButton.setScale(1, 1);
    const backSize = this.backButton.getSize();
    const backScaleX = (width * 0.07) / backSize.width;
    const backScaleY = (height * 0.07) / backSize.height;
    neededScale = backScaleX > backScaleY ? backScaleX : backScaleY;
    this.backButton.setScale(neededScale, neededScale);
    this.backButton.setPosition(100 * neededScale, height - 100 * neededScale);
  }
};
/**
 *
 */

export default EDC.Games.GradeSelect.Scenes.Main;
